import { render, staticRenderFns } from "./CellRendererCustomTagComments.vue?vue&type=template&id=2f6fa46a"
import script from "./CellRendererCustomTagComments.vue?vue&type=script&lang=js"
export * from "./CellRendererCustomTagComments.vue?vue&type=script&lang=js"
import style0 from "./CellRendererCustomTagComments.vue?vue&type=style&index=0&id=2f6fa46a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports